import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { ContractNumberArea } from "./Styles";

export default function Contrato({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="No. Contrato"
            value={!value ? document.documents.contract.number : value}
          />
        </div>
      ) : (
        <ContractNumberArea>
          <Informative
            readonly={true}
            label="No. Contrato"
            value={!value ? document.documents.contract.number : value}
          />
        </ContractNumberArea>
      )}
    </>
  );
}
